import {UIGamePlayerInformationLongestRoadController} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLongestRoadController'
import {UIMGamePlayerInformationLongestRoadView} from './UIMGamePlayerInformationLongestRoadView'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {MechanicLongestRoadState} from '@colonist/game-states'
import {UIGamePlayerInformationLongestRoadView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLongestRoadView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

/**
 * @deprecated UIMGamePlayerInformationLongestRoadController will be removed once Pixi.js Mobile Player Information view is removed. Please use UIGamePlayerInformationLongestRoadController.
 */
export class UIMGamePlayerInformationLongestRoadController extends UIGamePlayerInformationLongestRoadController {
    private playerInformationLongestRoadViews: UIGamePlayerInformationLongestRoadView[]

    constructor(uiGameManager: UIGameManager, longestRoadState: MechanicLongestRoadState) {
        super(uiGameManager, longestRoadState)

        this.playerInformationLongestRoadViews = []

        this.initPlayerLongestRoadViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        super.onEvent(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.initPlayerLongestRoadViews(); break
            default: break
        }
    }

    private initPlayerLongestRoadViews() {
        if(this.uiGameManager.playersController == undefined) return
        this.playerInformationLongestRoadViews.forEach((view) => view.destroy())
        this.playerInformationLongestRoadViews = []

        for(const playerState of this.uiGameManager.gameState.players) {
            const newPlayerInformationLongestRoadView = this.createLongestRoadView(playerState)
            this.playerInformationLongestRoadViews.push(newPlayerInformationLongestRoadView)
        }
    }
    private createLongestRoadView(playerState: PlayerValidator) {
        return new UIMGamePlayerInformationLongestRoadView(this.uiGameManager, playerState)
    }
}
